import type DataHandler from '@atpoint/atpjs/data_handler'
import i18n from '@atpoint/atpjs/helpers/i18n'
import WebForms from '@forms/views/web_forms'
import { StylesProvider, ThemeProvider, createGenerateClassName } from '@material-ui/core'
import { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { AppContainer as ReactHotAppContainer } from 'react-hot-loader'
import { getFromUrl } from 'swisscard/helpers/get_from_url'
import { mapTheme } from 'swisscard/helpers/theme'

import type { ThemeKey } from 'swisscard/helpers/theme'

// biome-ignore lint/nursery/useComponentExportOnlyModules: keeping this pattern.
const AppContainer = process.env.NODE_ENV === 'development' ? ReactHotAppContainer : Fragment

const generateClassName = createGenerateClassName({
  seed: 'atp-forms',
  productionPrefix: 'atp-forms',
})

export const initializeApp = (
  rootElement: HTMLElement,
  dataHandler: DataHandler,
  formsKey: string | null | undefined,
  formsTheme: ThemeKey,
) => {
  i18n.locale = getFromUrl('locale') || (dataHandler.get('locale') as string)
  const key = formsKey || getFromUrl('key') || ''
  const theme = mapTheme((getFromUrl('theme') as ThemeKey) || formsTheme)

  ReactDOM.render(
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <AppContainer>
          <WebForms locale={i18n.locale} id={key} />
        </AppContainer>
      </ThemeProvider>
    </StylesProvider>,
    rootElement,
  )
}
